/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_PrivacyInputs */

const en_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const de_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz`)
};

const fr_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentialité`)
};

const es_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad`)
};

const it_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const nl_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const pl_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność`)
};

const fi_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuoja`)
};

const da_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitik`)
};

const sv_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetspolicy`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Landing_Footer_PrivacyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_footer_privacy = /** @type {((inputs?: Landing_Footer_PrivacyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_PrivacyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_footer_privacy(inputs)
	if (locale === "fr") return fr_landing_footer_privacy(inputs)
	if (locale === "es") return es_landing_footer_privacy(inputs)
	if (locale === "it") return it_landing_footer_privacy(inputs)
	if (locale === "nl") return nl_landing_footer_privacy(inputs)
	if (locale === "pl") return pl_landing_footer_privacy(inputs)
	if (locale === "fi") return fi_landing_footer_privacy(inputs)
	if (locale === "da") return da_landing_footer_privacy(inputs)
	if (locale === "sv") return sv_landing_footer_privacy(inputs)
	return en_landing_footer_privacy(inputs)
});